<script setup lang="ts">
import { ref, computed, onBeforeUnmount } from "vue";
import { formatTime } from "@/utils/index"
defineExpose({
  startStop,
  start,
  stop,
});

const elapsedTime = ref<number>(0);
const interval = ref<ReturnType<typeof setInterval> | null>(null);
const isRunning = ref(false);

// This variable holds the timestamp when the timer started (or resumed)
let startTimestamp: number | null = null;

const formattedTime = computed(() => {
  const minutes = Math.floor(elapsedTime.value / 60000);
  const seconds = Math.floor((elapsedTime.value % 60000) / 1000);

  const result = formatTime(0, minutes, seconds, 0)
  return result
  
});



// Update the elapsedTime based on the current time and the stored start timestamp.
function updateElapsedTime() {
  if (startTimestamp !== null) {
    elapsedTime.value = Date.now() - startTimestamp;
  }
}

function startStop(eventFromParent?: boolean) {
  if (interval.value && eventFromParent) return;

  if (isRunning.value && interval.value) {
    // Stop timer: clear the interval and update state
    clearInterval(interval.value);
    interval.value = null;
    isRunning.value = false;
  } else {
    // Start or resume timer:
    // Calculate the effective start time by subtracting any already elapsed time
    startTimestamp = Date.now() - elapsedTime.value;
    interval.value = setInterval(updateElapsedTime, 10);
    isRunning.value = true;
  }
}

function start(startTime: string | number | null = null) {
  if (interval.value) return;
  // Reset the timer and start from zero
  elapsedTime.value = 0;
  if (!startTime) {
    startTimestamp = Date.now();
  } else {
    try {
      startTimestamp = new Date(startTime).getTime()
    } catch {
      startTimestamp = Date.now();
    }
    
  }
  
  interval.value = setInterval(updateElapsedTime, 10);
  isRunning.value = true;
}

function stop() {
  if (isRunning.value && interval.value) {
    clearInterval(interval.value);
    interval.value = null;
  }
  isRunning.value = false;
}

onBeforeUnmount(() => {
  if (interval.value) clearInterval(interval.value);
});
</script>

<template>
  {{ formattedTime }}
</template>
